import { isNil } from 'lodash';
import Filter from './Filter';

/**
 * Super simple filter that just holds a value
 */
class ValueFilter<T> extends Filter {
  value: T;

  constructor(value: T) {
    super();
    this.set(value);
  }

  toBookmarkConfiguration() {
    return this.getValue();
  }

  /**
   * @param {T} value
   */
  set(value: T) {
    this.value = value;
  }

  getValue(): T {
    return this.value;
  }

  get hasValue() {
    return !isNil(this.value);
  }
}

export default ValueFilter;
